export default "__VITE_ASSET__ZhkleKR5__"